(() => {
  if (window.wvrQuickShopInitialized) return;
  window.wvrQuickShopInitialized = true;
  const uncertainProducts = new Set();
  let submitting = false;
  const initialize = scope => {
    scope.querySelectorAll('[data-wvr-quick-shop]').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const listeners = new AbortController();
      const copy = dialog.dataset;
      const find = name => dialog.querySelector(`[data-wvr-quick-${name}]`);
      const title = find('title');
      const price = find('price');
      const gallery = find('gallery');
      const image = find('image');
      const thumbnails = find('thumbnails');
      const form = find('form');
      const fields = find('fields');
      const selector = find('variant');
      const quantity = find('quantity');
      const availability = find('availability');
      const add = find('add');
      const status = find('status');
      const error = find('error');
      const details = find('details');
      const cart = find('cart');
      let product;
      let productUrl;
      let opener;
      let loadRequest;
      let loadVersion = 0;
      let priorOverflow;
      let closeTask;
      let resolveClose;
      const root = new URL(window.Shopify?.routes?.root || copy.root || '/', window.location.origin);
      if (root.origin !== window.location.origin) return;
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      const money = amount => new Intl.NumberFormat(copy.locale || document.documentElement.lang || 'de', {
        style: 'currency', currency: window.Shopify?.currency?.active || copy.currency
      }).format(amount / 100);
      const safeImage = source => {
        try {
          const address = new URL(typeof source === 'string' ? source : source?.src, window.location.origin);
          return ['https:', 'http:'].includes(address.protocol) && source ? address.href : null;
        } catch { return null; }
      };
      const sizedImage = (source, width) => {
        const address = new URL(source);
        const shopifyCdn = address.hostname === 'cdn.shopify.com' || address.hostname === 'cdn.shopifycdn.net' || address.hostname.endsWith('.shopifycdn.com') || (address.origin === window.location.origin && address.pathname.startsWith('/cdn/shop/'));
        if (shopifyCdn) {
          const existingWidth = Number(address.searchParams.get('width'));
          address.searchParams.set('width', String(existingWidth > 0 ? Math.min(existingWidth, width) : width));
        }
        return address.href;
      };
      const showImage = source => {
        const address = safeImage(source);
        if (!address) return;
        image.src = sizedImage(address, 1200);
        image.alt = product.title;
        image.hidden = false;
        gallery.hidden = false;
        thumbnails.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.image === address)));
      };
      const showError = message => {
        error.textContent = message;
        error.hidden = false;
      };
      const selectedVariant = () => product?.variants.find(variant => String(variant.id) === selector.value);
      const unsupportedVariant = variant => variant?.requires_selling_plan || variant?.requires_components || variant?.selling_plan_allocations?.length > 0;
      const quantityValid = () => Number.isSafeInteger(quantity.valueAsNumber) && quantity.valueAsNumber > 0 && quantity.checkValidity();
      const updateAdd = () => {
        const variant = selectedVariant();
        add.disabled = submitting || fields.disabled || !variant?.available || unsupportedVariant(variant) || uncertainProducts.has(String(product?.id)) || !quantityValid();
      };
      const updateVariant = () => {
        const variant = selectedVariant();
        error.hidden = true;
        if (uncertainProducts.has(String(product?.id))) showError(copy.uncertain);
        status.textContent = '';
        const address = new URL(productUrl);
        if (variant) address.searchParams.set('variant', variant.id);
        details.href = address.href;
        if (!variant) {
          price.textContent = product.price_min === product.price_max ? money(product.price_min) : `${money(product.price_min)} – ${money(product.price_max)}`;
          availability.textContent = copy.select;
          updateAdd();
          return;
        }
        price.textContent = money(variant.price);
        availability.textContent = unsupportedVariant(variant) ? copy.unsupported : variant.available ? copy.available : copy.unavailable;
        const rule = variant.quantity_rule || {};
        quantity.min = String(rule.min || 1);
        quantity.step = String(rule.increment || 1);
        if (rule.max != null) quantity.max = String(rule.max);
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        showImage(variant.featured_image || product.featured_image || product.images?.[0]);
        updateAdd();
      };
      const close = () => {
        if (closeTask) return closeTask;
        if (!dialog.open) return Promise.resolve();
        closeTask = new Promise(resolve => { resolveClose = resolve; });
        dialog.close();
        return closeTask;
      };
      dialog.addEventListener('close', () => {
        loadRequest?.abort();
        loadVersion += 1;
        document.documentElement.style.overflow = priorOverflow || '';
        if (!document.querySelector('dialog[open]') && !document.documentElement.classList.contains('js-drawer-open')) opener?.focus({ preventScroll: true });
        resolveClose?.();
        resolveClose = null;
        closeTask = null;
      });
      find('close').addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const targets = [...dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), [tabindex="0"]')].filter(element => element.getClientRects().length > 0);
        const first = targets[0];
        const last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
      });
      document.addEventListener('click', async event => {
        const trigger = event.target.closest('[data-wvr-quick-open]');
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (submitting || closeTask) { event.preventDefault(); return; }
        if (document.querySelector('dialog[open]') || document.documentElement.classList.contains('js-drawer-open')) return;
        const address = new URL(trigger.href, window.location.origin);
        if (address.origin !== window.location.origin || !trigger.dataset.productHandle) return;
        event.preventDefault();
        opener = trigger;
        product = null;
        productUrl = new URL(`products/${encodeURIComponent(trigger.dataset.productHandle)}`, root).href;
        details.href = productUrl;
        title.textContent = copy.loading;
        price.textContent = '';
        status.textContent = copy.loading;
        error.hidden = true;
        cart.hidden = true;
        fields.hidden = true;
        fields.disabled = true;
        add.disabled = true;
        add.textContent = copy.add;
        selector.replaceChildren();
        thumbnails.replaceChildren();
        gallery.hidden = true;
        image.hidden = true;
        image.removeAttribute('src');
        availability.textContent = '';
        priorOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        find('close').focus();
        dialog.scrollTop = 0;
        loadRequest?.abort();
        loadRequest = new AbortController();
        const version = ++loadVersion;
        const timeout = setTimeout(() => loadRequest.abort(), 15000);
        try {
          const response = await fetch(`${productUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal: loadRequest.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Product response failed');
          const current = await response.json();
          if (version !== loadVersion || !dialog.open) return;
          if (String(current.id) !== trigger.dataset.productId || !Array.isArray(current.variants) || !current.variants.length || typeof current.title !== 'string' || !Number.isFinite(current.price_min) || !Number.isFinite(current.price_max) || current.variants.some(variant => !Number.isSafeInteger(variant.id) || !Number.isFinite(variant.price))) throw new Error('Invalid product response');
          product = current;
          title.textContent = product.title;
          const images = [...new Set([product.featured_image, ...(product.images || [])].map(safeImage).filter(Boolean))];
          images.forEach((source, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.image = source;
            button.setAttribute('aria-label', copy.image.replace('{number}', index + 1));
            button.setAttribute('aria-pressed', 'false');
            const preview = document.createElement('img');
            preview.src = sizedImage(source, 120);
            preview.alt = '';
            preview.loading = 'lazy';
            preview.width = 60;
            preview.height = 60;
            button.append(preview);
            button.addEventListener('click', () => showImage(source));
            thumbnails.append(button);
          });
          showImage(images[0]);
          const unsupported = trigger.dataset.requiresSelection === 'true' || product.requires_selling_plan || product.selling_plan_groups?.length > 0 || product.gift_card || product.requires_components || Number(trigger.dataset.variantCount) >= 250 || product.variants.length >= 250 || Number(trigger.dataset.variantCount) > product.variants.length;
          price.textContent = product.price_min === product.price_max ? money(product.price_min) : `${money(product.price_min)} – ${money(product.price_max)}`;
          if (unsupported) { status.textContent = copy.unsupported; return; }
          const optionNames = (product.options || []).map(option => typeof option === 'string' ? option : option.name).filter(Boolean);
          find('option-label').textContent = optionNames.join(' / ') || copy.select;
          const defaultOnly = product.variants.length === 1 && product.variants[0].title === 'Default Title' && optionNames.length === 1 && optionNames[0] === 'Title';
          selector.hidden = defaultOnly;
          find('option-label').hidden = defaultOnly;
          if (product.variants.length > 1) selector.append(new Option(copy.select, '', true, true));
          product.variants.forEach(variant => {
            const label = `${variant.title}${variant.available ? '' : ` — ${copy.unavailable}`}`;
            selector.append(new Option(label, String(variant.id)));
          });
          fields.hidden = false;
          fields.disabled = false;
          updateVariant();
          if (uncertainProducts.has(String(product.id))) {
            showError(copy.uncertain);
            cart.hidden = false;
          }
        } catch {
          if (version === loadVersion && dialog.open) {
            title.textContent = copy.select;
            status.textContent = '';
            showError(copy.loadError);
            fields.hidden = true;
            fields.disabled = true;
          }
        } finally { clearTimeout(timeout); }
      }, { signal: listeners.signal });
      selector.addEventListener('change', updateVariant);
      quantity.addEventListener('input', updateAdd);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const variant = selectedVariant();
        if (submitting || !dialog.open || fields.disabled || !variant?.available || unsupportedVariant(variant) || uncertainProducts.has(String(product?.id)) || !quantityValid() || !form.reportValidity()) return;
        submitting = true;
        fields.disabled = true;
        add.disabled = true;
        add.textContent = copy.adding;
        form.setAttribute('aria-busy', 'true');
        error.hidden = true;
        status.textContent = copy.adding;
        const selectedQuantity = quantity.valueAsNumber;
        const productId = String(product.id);
        const request = new AbortController();
        const timeout = setTimeout(() => request.abort(), 20000);
        let confirmedFailure = false;
        let confirmedSuccess = false;
        try {
          const response = await fetch(new URL('cart/add.js', root), {
            method: 'POST', credentials: 'same-origin', signal: request.signal,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: selectedQuantity }] })
          });
          const result = await response.json();
          if (!response.ok) {
            confirmedFailure = response.status >= 400 && response.status < 500;
            if (confirmedFailure) showError(typeof result.description === 'string' ? result.description : copy.addError);
            throw new Error('Cart response failed');
          }
          if (!Array.isArray(result.items) || !result.items.some(item => String(item.variant_id || item.id) === String(variant.id))) throw new Error('Unconfirmed cart response');
          confirmedSuccess = true;
          status.textContent = copy.added;
          cart.hidden = false;
          const announcement = document.querySelector('[data-wvr-quick-announcement]');
          if (announcement) announcement.textContent = `${copy.added} ${product.title}`;
          await close();
          document.dispatchEvent(new CustomEvent('cart:build'));
          const drawer = document.getElementById('CartDrawer');
          if (drawer && window.theme?.CartDrawer && (window.theme?.settings?.cartType === 'drawer' || drawer.dataset.wvrReady === 'true')) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else window.location.assign(cart.href);
        } catch {
          status.textContent = confirmedSuccess ? copy.added : '';
          cart.hidden = false;
          if (!confirmedFailure && !confirmedSuccess) {
            uncertainProducts.add(productId);
            showError(copy.uncertain);
          }
        } finally {
          clearTimeout(timeout);
          submitting = false;
          fields.disabled = confirmedSuccess;
          add.textContent = confirmedSuccess ? copy.added : copy.add;
          form.removeAttribute('aria-busy');
          updateAdd();
        }
      });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(dialog)) return;
        close();
        loadRequest?.abort();
        listeners.abort();
      }, { signal: listeners.signal });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
